<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">冷热分析</span>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <template v-if="lenReStatsList">
        <div class="content-8__controlbar">
          <div class="content-8__controlbar__item">
            <div class="c8-explanation">
              <span class="c8-explanation__title">说明：</span>
              <div class="c8-explanation__content">
                <p>热码，指近20期内出现频繁、活跃的号码；冷码，指近20期出现频率低甚至没有出现的号码；温码，指介于冷热之间的号码。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content-8__content">
          <table class="even-color">
            <thead>
              <tr>
                <th
                  v-for="column in columnKeys"
                  :key="column.label"
                  :style="column.style"
                >{{ column.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rowKeys" :key="row.rowLabel">
                <td v-for="column in columnKeys" :key="column.label">
                  <template v-if="column.key === 'position'">{{ row.rowLabel }}</template>
                  <div v-else class="tableballbox">
                    <div
                      v-for="ball in lenReStatsList[row.key][column.key]"
                      :key="`${row.key}-${column.key}-${ball.num}`"
                      class="tableballbox__item"
                    >
                      <div
                        class="ball size-middle"
                        :class="setBallClass({ballNum: ball.num, ballType: column.key})"
                      >
                        <span class="ball__number">{{ ball.num }}</span>
                        <div v-if="column.key === 'hot'" class="ball__subnumber">
                          <span class="ball__subnumber__text">{{ ball.count }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { getCPStatistics_web } from '@/api/desktop/statistic'
import { fieldList } from '@/utils/forWeb-Sean/lenRe'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'WebLengReFenXi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,
      lenReStatsList: null,
      isLoading: false,
      lotteryBallClass: {}
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.getLengReFenXiStatistics(this.lotteryCode)
  },
  methods: {
    async getLengReFenXiStatistics(code) {
      this.isLoading = true
      const [data, error] = await getCPStatistics_web(code, 'numberHeat')
      if (error) return
      this.lenReStatsList = this.formatLenReStatsList(data)
      this.isLoading = false
    },
    formatLenReStatsList(data) {
      return data.reduce((acc, value, index) => {
        const obj = {
          hot: value.hot.sort((a, b) => a.num - b.num),
          cold: value.cold.sort((a, b) => a.num - b.num),
          warm: value.warm.sort((a, b) => a.num - b.num)
        }
        acc[value.field] = obj
        return acc
      }, {})
    },
    setBallClass({ ballNum, ballType }) {
      const circleClass = 'circle'
      let ballClass
      switch (this.lotteryType) {
        case 'pk10':
          return ballNum === 10 ? `ball-${ballNum}` : `ball-0${ballNum}`
        case '11x5':
        case 'ssc':
          ballClass =
            ballType === 'hot'
              ? 'color--red'
              : ballType === 'warm'
                ? 'color--orange'
                : 'color--blue'
          return circleClass.concat(' ', ballClass)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
table {
  table-layout: fixed;
}
</style>
